//Generated File 
export const LogOut = `LogOut`;
export const accept = `accept`;
export const approval = `approval`;
export const autoFitCols = `autoFitCols`;
export const changeLocale = `changeLocale`;
export const chooseSortFields = `chooseSortFields`;
export const $delete = `delete`;
export const duplicate = `duplicate`;
export const exportAsDOCX = `exportAsDOCX`;
export const exportAsODS = `exportAsODS`;
export const exportAsODT = `exportAsODT`;
export const exportAsPDF = `exportAsPDF`;
export const exportAsPPTX = `exportAsPPTX`;
export const exportAsRTF = `exportAsRTF`;
export const exportAsTXT = `exportAsTXT`;
export const exportAsXLS = `exportAsXLS`;
export const exportAsXLSX = `exportAsXLSX`;
export const filterAndSort = `filterAndSort`;
export const first = `first`;
export const generalSearch = `generalSearch`;
export const go = `go`;
export const goToRecord = `goToRecord`;
export const homePage = `homePage`;
export const last = `last`;
export const listView = `listView`;
export const more = `more`;
export const newRecord = `newRecord`;
export const next = `next`;
export const previous = `previous`;
export const print = `print`;
export const printAs = `printAs`;
export const refresh = `refresh`;
export const reportRelaunch = `reportRelaunch`;
export const reportZoomIn = `reportZoomIn`;
export const reportZoomOut = `reportZoomOut`;
export const resultSettings = `resultSettings`;
export const revise = `revise`;
export const rowAppend = `rowAppend`;
export const rowDelete = `rowDelete`;
export const rowDown = `rowDown`;
export const rowInsert = `rowInsert`;
export const rowUp = `rowUp`;
export const save = `save`;
export const saveAndContinue = `saveAndContinue`;
export const sendEmailWithResult = `sendEmailWithResult`;
export const showHelpMsgs = `showHelpMsgs`;
export const toggleSortDirection = `toggleSortDirection`;
export const treeView = `treeView`;
export const unrevise = `unrevise`;
